import {
  NavigateWithThread,
  FocusDashboard,
  CallsPage,
  CallRecordDetailPage,
  CallEvaluationsPage,
} from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { CallOutcomesPage } from '../components/call-outcomes-page'

interface CallOperatorRoutesProps {
  onStartConversation?: (message: string) => void
}

export function CallOperatorRoutes({ onStartConversation }: CallOperatorRoutesProps) {
  return (
    <Routes>
      <Route index element={<FocusDashboard focus="operator" onStartConversation={onStartConversation} />} />
      <Route path="records" element={<CallsPage />} />
      <Route path="records/:id" element={<CallRecordDetailPage />} />
      <Route path="evaluations" element={<CallEvaluationsPage />} />
      <Route path="outcomes" element={<CallOutcomesPage />} />
      <Route path="*" element={<NavigateWithThread to="/calls" />} />
    </Routes>
  )
}
